import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Question, QuestionFilter } from "@app-model/questions";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class QuestionsService {
  constructor(private http: HttpClient) {}

  searchQuestions(filter: QuestionFilter): Observable<Question[]> {
    return this.http.post(
      environment.api + 'questions/question/subAreasAndAreas',
      filter
    ) as Observable<Question[]>;
  }
}
